import type { LandingPageFeature } from '@/app/components/LandingPage/LandingPageFeatures/types';

const stressFeatures: LandingPageFeature[] = [
  {
    id: 'daytime_stress',
    title: 'stress_features_title_1',
    description: 'stress_features_copy_1',
    image: {
      format: 'svg',
      localizedAlt: 'stress_app_ui_daytime_alt',
      localizedSrc: 'stress_app_ui_daytime',
    },
  },
  {
    id: 'resillience',
    title: 'stress_features_title_2',
    description: 'stress_features_copy_2',
    image: {
      format: 'svg',
      localizedAlt: 'stress_app_ui_resilience_alt',
      localizedSrc: 'stress_app_ui_resilience',
    },
  },
  {
    id: 'restorative',
    title: 'stress_features_title_3',
    description: 'stress_features_copy_3',
    image: {
      format: 'svg',
      localizedAlt: 'stress_app_ui_daytime_alt',
      localizedSrc: 'stress_app_ui_restorative',
    },
  },
  {
    id: 'hrv',
    title: 'stress_features_title_4',
    description: 'stress_features_copy_4',
    image: {
      format: 'svg',
      localizedAlt: 'stress_app_ui_hrv_alt',
      localizedSrc: 'stress_app_ui_hrv',
    },
  },
];

export default stressFeatures;
